import { Accordion, Alert } from "@swot/base-components";

export function CmtsPageHintPanel(props: { title?: string | undefined; children: string; defaultOpen?: boolean | undefined }) {
  if (props.defaultOpen) {
    return (
      <Alert title={props.title ?? "How to use this page"} tone="info">
        {props.children}
      </Alert>
    );
  }
  return (
    <Accordion title={props.title ?? "How to use this page"}>
      <p>{props.children}</p>
    </Accordion>
  );
}

export function CmtsActionHint(props: { children: string }) {
  return <Alert title="Action guidance" tone="info">{props.children}</Alert>;
}
